import { AlertStrings } from 'src/clients-internal/strings.model';
import { Markdown } from '../../details/Markdown';
import { AlertWrapper } from './AlertWrapper';

interface Props {
    alerts: AlertStrings;
}

export const StringsAlertWrapper = ({
    alerts: { info, warning, danger },
}: Props): React.ReactElement<any, any> | null => {
    return (
        <>
            {danger && (
                <AlertWrapper variant="danger" icon="exclamation-triangle">
                    <Markdown source={danger} />
                </AlertWrapper>
            )}
            {warning && (
                <AlertWrapper variant="warning" icon="bell">
                    <Markdown source={warning} />
                </AlertWrapper>
            )}
            {info && (
                <AlertWrapper variant="info" icon="info-circle">
                    <Markdown source={info} />
                </AlertWrapper>
            )}
        </>
    );
};
